import React, { PropsWithChildren } from 'react';
import {
  PositionInSelectionInformation,
  SkipLinkTo,
} from '../../../../components/molecules/Form/components/FormsComboboxMultiSelect/partials/CommonSkipLinks';
import bem from '../../../../lib/bemUtils/bem';
import { useHtmlValidId } from '../../../../hooks/useHtmlValidId';
import { Heading, HeadingHierarchy } from '../../../components/Heading/Heading';

type SelectList = PropsWithChildren<{
  id: string;
  headline?: string;
  headlineLevel?: HeadingHierarchy;
  hiddenHeadline?: boolean;
  noElementsPhrase?: string;
  shouldHaveSkipLinks: boolean;
  headlineIdPrefix?: string; // sometimes used in QF Test
}>;

export function SelectList({
  id,
  headline,
  headlineLevel = 3,
  headlineIdPrefix,
  hiddenHeadline,
  noElementsPhrase,
  shouldHaveSkipLinks,
  children,
}: SelectList) {
  let ariaLabeledById = useHtmlValidId();

  if (headlineIdPrefix) {
    ariaLabeledById = headlineIdPrefix + ariaLabeledById;
  }

  return (
    <div id={id} className="select-list">
      {headline ? (
        <div className={hiddenHeadline ? 'invisible' : 'select-list__label-container'}>
          <Heading hierarchy={headlineLevel} id={ariaLabeledById} className="select-list__label">
            {headline}
          </Heading>
        </div>
      ) : null}
      {shouldHaveSkipLinks ? (
        <>
          <PositionInSelectionInformation position="top" />
          <SkipLinkTo target="bottom" />
        </>
      ) : null}
      {React.Children.count(children) > 0 ? (
        <ul className={bem('select-list__list')} aria-labelledby={headline ? ariaLabeledById : undefined}>
          {children}
        </ul>
      ) : (
        <p className="select-list__no-items font-regular-15-21">{noElementsPhrase}</p>
      )}
      {shouldHaveSkipLinks ? (
        <>
          <PositionInSelectionInformation position="bottom" />
          <SkipLinkTo target="top" />
        </>
      ) : null}
    </div>
  );
}
